import React, { memo } from 'react';
import { Game } from '../Game';

import style from './OverflowSlider.scss';

// Duplicate of GoldenChipsBalances components.
// Since we need to use it for all accordion tables - these components moved here.

export const OverflowSlider = memo(({ gameCodes }: { gameCodes: string[] }) => (
    <div className={style.games}>
        {gameCodes.map(code =>
            <Game
                key={code}
                code={code}
                className={style.game}
            />
        )}
    </div>
));
